import React from "react";

import { DEAL_TYPE_KEYS, ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { useCheckClassificationPreclinical } from "@FillInTableContainer/components/FillInTable/components/TableCreator/components/ClinicalTrialsTableCreator/hooks/useCheckClassificationPreclinical";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useHandleTableCreatorWrapperPositionInfo } from "@FillInTableContainer/shared/hooks/useHandleTableCreatorWrapperPositionInfo";
import { ArticleSectionType } from "@FillInTableContainer/types/fillInTable.types";

import FillInTableNavigation from "./components/FillInTableNavigation/FillInTableNavigation";
import { NAVIGATION_LIST } from "./constants/fillInTableNavigationList.constants";
import * as S from "./TableCreatorNavigationTableWrapper.style";

interface Props {
  classificationKey: ArticleSectionType;
  children: JSX.Element;
}

const TableCreatorNavigationTableWrapper = ({
  classificationKey,
  children,
}: Props) => {
  const { tableCreatorWrapperRef } = useHandleTableCreatorWrapperPositionInfo();

  const { isMergeAndAcquisition, currentDealTypeList } =
    useCurrentDealTypeValue();

  const { isPreclinical } = useCheckClassificationPreclinical();
  const returnNavigationList = () => {
    if (isPreclinical) {
      // NOTE : Preclinical인 경우 Drug Profile 메뉴만 표출
      return NAVIGATION_LIST[classificationKey].filter(
        (item) => item.sectionKey === "Drug Profile",
      );
    }
    if (classificationKey === ENTRY_DATA_SECTION_KEYS.deals) {
      // NOTE : Deals인 경우 Merge & Acquisition 또는 Venture Formation 타입인 경우 Deal Terms & Additional Information (New) 및 Key Comment (New) 메뉴 표출
      if (
        isMergeAndAcquisition ||
        (currentDealTypeList.includes(DEAL_TYPE_KEYS.ventureFormation) &&
          !currentDealTypeList.includes(DEAL_TYPE_KEYS.licenseAgreement))
      )
        return NAVIGATION_LIST[classificationKey];
      return [
        ...NAVIGATION_LIST[classificationKey],
        ...NAVIGATION_LIST[ENTRY_DATA_SECTION_KEYS.dealsLaSc],
      ];
    }

    return NAVIGATION_LIST[classificationKey];
  };
  const currentNavigationList = returnNavigationList();

  return (
    <S.TableCreatorWrapper>
      <FillInTableNavigation itemList={currentNavigationList} />
      <S.GroupTableWrapper ref={tableCreatorWrapperRef}>
        {children}
      </S.GroupTableWrapper>
    </S.TableCreatorWrapper>
  );
};

export default TableCreatorNavigationTableWrapper;
